/* ===================================================================
   THE FLOAT CLUB — fc-commerce.js
   Currency display, cart drawer, and Shopify checkout hand-off.

   CURRENCY IS DISPLAY ONLY. Shopify charges in GBP. Every non-GBP
   price on this site is an indicative conversion from a static rate
   table, stamped with the date it was set, and every surface that
   shows one also says the customer is charged in USD. Do not remove
   that disclosure — showing a converted price without it means the
   customer sees one number and their bank charges another.

   To refresh rates: update RATES and RATES_DATE together. Nothing
   fetches live FX (no API key on this site, and a silently failing
   fetch would leave stale numbers looking authoritative).
=================================================================== */
(function (global) {
  "use strict";

  /* ---------------------------------------------------------------
     SOCIAL LINKS — fill these in and the icons appear. Left empty,
     the icons are removed rather than shown as dead links: every one
     of them used to point at "#buy", which sent someone expecting
     Instagram to the checkout section instead.
  --------------------------------------------------------------- */
  var SOCIAL = {
    email: "",      // e.g. "mailto:hello@thefloatclub.com"
    instagram: "",  // e.g. "https://instagram.com/thefloatclub"
    tiktok: ""      // e.g. "https://tiktok.com/@thefloatclub"
  };

  /* ---------------------------------------------------------------
     ORDER FALLBACK — used only while Shopify is not yet connected.
     With an address or number here the checkout button still places a
     real order by email or WhatsApp, itemised, instead of being dead.
     Set ORDER_EMAIL or ORDER_WHATSAPP (international format, digits
     only, no + or spaces).
  --------------------------------------------------------------- */
  var ORDER_EMAIL = "";
  var ORDER_WHATSAPP = "";

  function orderFallbackUrl() {
    var lines = cart.map(function (i) {
      return i.qty + " x " + i.colour + ", size " + i.size;
    }).join("\n");
    var body = "I would like to order:\n\n" + lines +
      "\n\nTotal: " + fmt(totalGBP()) +
      (isConverted() ? " (charged as " + "$" + totalGBP().toFixed(2) + ")" : "");
    if (ORDER_WHATSAPP) {
      return "https://wa.me/" + ORDER_WHATSAPP + "?text=" + encodeURIComponent(body);
    }
    if (ORDER_EMAIL) {
      return "mailto:" + ORDER_EMAIL +
        "?subject=" + encodeURIComponent("Float Club order") +
        "&body=" + encodeURIComponent(body);
    }
    return null;
  }

  function wireSocial() {
    document.querySelectorAll("[data-social]").forEach(function (a) {
      var url = SOCIAL[a.getAttribute("data-social")];
      if (url) {
        a.setAttribute("href", url);
        if (url.indexOf("http") === 0) {
          a.setAttribute("target", "_blank");
          a.setAttribute("rel", "noopener noreferrer");
        }
      } else if (a.parentNode) {
        a.parentNode.removeChild(a);
      }
    });
    // drop any social cluster left empty, AND its heading, so no orphaned
    // "Follow the club" label is left sitting above nothing
    document.querySelectorAll("[data-m='hero-social'],[data-m='mnav-social'],[data-m='cta-social']")
      .forEach(function (g) {
        if (g.querySelector("a") || !g.parentNode) return;
        var label = g.previousElementSibling;
        if (label && /follow/i.test(label.textContent || "")) {
          label.parentNode.removeChild(label);
        }
        g.parentNode.removeChild(g);
      });
  }

  /* ---------------------------------------------------------------
     TRACKING — a carrier-agnostic parcel lookup in the drawer footer.
     17TRACK is free and does not need an account or a carrier picked
     up front, so a raw tracking number is enough to send someone
     straight to a result instead of asking them to identify the
     courier first.
  --------------------------------------------------------------- */
  function wireTracking() {
    var btn = el("fc-track-btn");
    var input = el("fc-track-input");
    if (!btn || !input) return;
    function go() {
      var v = input.value.trim();
      if (!v) return;
      global.open("https://t.17track.net/en#nums=" + encodeURIComponent(v), "_blank", "noopener,noreferrer");
    }
    btn.addEventListener("click", go);
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); go(); }
    });
  }

  /* ---------------------------------------------------------------
     PRICING — the locked GBP numbers. Bundle totals come from fixed
     deductions, not percentages, so they match the two Shopify
     automatic discounts exactly (-8.75 at 2 units, -20.99 at 3+).
  --------------------------------------------------------------- */
  var UNIT_GBP = 44.99;
  var DISCOUNT_AT_2 = 9.99;
  var DISCOUNT_AT_3_PLUS = 24.98;

  function bundleDiscountGBP(qty) {
    if (qty >= 3) return DISCOUNT_AT_3_PLUS;
    if (qty === 2) return DISCOUNT_AT_2;
    return 0;
  }

  /* ---------------------------------------------------------------
     CURRENCY — static table. Update RATES and RATES_DATE together.
  --------------------------------------------------------------- */
  var RATES_DATE = "3 August 2026";
  var CURRENCIES = {
    USD: { symbol: "$",  rate: 1,    label: "USD" },
    GBP: { symbol: "£",  rate: 0.79, label: "GBP" },
    EUR: { symbol: "€",  rate: 0.92, label: "EUR" },
    AUD: { symbol: "A$", rate: 1.53, label: "AUD" },
    CAD: { symbol: "C$", rate: 1.36, label: "CAD" }
  };

  var LOCALE_TO_CURRENCY = {
    "en-ca": "CAD", "fr-ca": "CAD", "en-au": "AUD", "en-nz": "AUD",
    "de": "EUR", "fr": "EUR", "es": "EUR", "it": "EUR", "nl": "EUR", "pt": "EUR",
    "ga": "EUR", "fi": "EUR", "el": "EUR"
  };

  function detectCurrency() {
    var saved = null;
    try { saved = localStorage.getItem("fc_currency"); } catch (e) {}
    if (saved && CURRENCIES[saved]) return saved;

    var loc = (navigator.language || "en-GB").toLowerCase();
    if (LOCALE_TO_CURRENCY[loc]) return LOCALE_TO_CURRENCY[loc];
    var base = loc.split("-")[0];
    if (LOCALE_TO_CURRENCY[base]) return LOCALE_TO_CURRENCY[base];
    return "USD";
  }

  var currency = detectCurrency();

  function setCurrency(code) {
    if (!CURRENCIES[code]) return;
    currency = code;
    try { localStorage.setItem("fc_currency", code); } catch (e) {}
    renderAll();
  }

  // GBP amount -> display string in the active currency
  function fmt(gbp) {
    var c = CURRENCIES[currency];
    var v = gbp * c.rate;
    // round converted prices to a whole-ish figure so they don't imply
    // false precision on a rate that is only indicative
    var out = (currency === "GBP") ? v.toFixed(2) : (Math.round(v * 100) / 100).toFixed(2);
    return c.symbol + out;
  }

  function isConverted() { return currency !== "USD"; }

  /* ---------------------------------------------------------------
     CART — held in memory plus localStorage so a reload keeps it.
     items: [{ colour, size, qty }]
  --------------------------------------------------------------- */
  var cart = [];
  try {
    var stored = JSON.parse(localStorage.getItem("fc_cart") || "[]");
    if (Array.isArray(stored)) cart = stored.filter(function (i) {
      return i && i.colour && i.size && i.qty > 0;
    });
  } catch (e) { cart = []; }

  function persist() {
    try { localStorage.setItem("fc_cart", JSON.stringify(cart)); } catch (e) {}
  }

  function totalQty() {
    return cart.reduce(function (n, i) { return n + i.qty; }, 0);
  }

  function rawSubtotalGBP() { return totalQty() * UNIT_GBP; }

  function totalGBP() {
    return Math.max(0, rawSubtotalGBP() - bundleDiscountGBP(totalQty()));
  }

  function addItem(colour, size, qty) {
    qty = qty || 1;
    var found = cart.filter(function (i) {
      return i.colour === colour && i.size === size;
    })[0];
    if (found) found.qty += qty;
    else cart.push({ colour: colour, size: size, qty: qty });
    persist();
    renderAll();
    openDrawer();
  }

  function setQty(index, qty) {
    if (!cart[index]) return;
    if (qty <= 0) cart.splice(index, 1);
    else cart[index].qty = qty;
    persist();
    renderAll();
  }

  /* ---------------------------------------------------------------
     RENDER
  --------------------------------------------------------------- */
  function el(id) { return document.getElementById(id); }

  // cart contents round-trip through localStorage, so never trust them as markup
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function renderCurrencyUI() {
    var label = el("fc-cur-label");
    if (label) label.textContent = CURRENCIES[currency].label;

    document.querySelectorAll("[data-cur-opt]").forEach(function (b) {
      var on = b.getAttribute("data-cur-opt") === currency;
      b.setAttribute("aria-pressed", on ? "true" : "false");
      // Colour is NOT set here. These pills live on a dark header AND inside a
      // white drawer, so one hardcoded pair is wrong in one of the two places
      // (pale text on the white drawer was invisible). CSS owns the resting
      // colour per context; JS only marks which one is active.
      b.style.background = on ? "rgba(255,197,61,0.22)" : "transparent";
      b.style.color = on ? "#7A5200" : "";
      b.style.borderColor = on ? "rgba(214,152,20,0.6)" : "";
    });

    // every price that is a plain GBP amount re-renders in the active currency
    document.querySelectorAll("[data-gbp]").forEach(function (n) {
      n.textContent = fmt(parseFloat(n.getAttribute("data-gbp")));
    });
    document.querySelectorAll("[data-gbp-each]").forEach(function (n) {
      n.textContent = fmt(parseFloat(n.getAttribute("data-gbp-each"))) + " each";
    });

    document.querySelectorAll("[data-fx-note]").forEach(function (n) {
      n.style.display = isConverted() ? "" : "none";
      n.textContent = "Prices shown in " + CURRENCIES[currency].label +
        " are converted from GBP at a rate set on " + RATES_DATE +
        ". You are charged in USD at checkout.";
    });
  }

  function renderCart() {
    var count = totalQty();

    document.querySelectorAll("[data-cart-count]").forEach(function (n) {
      n.textContent = String(count);
      n.style.display = count > 0 ? "" : "none";
    });

    var list = el("fc-drawer-items");
    if (list) {
      if (!cart.length) {
        list.innerHTML = '' +
          '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;' +
                'text-align:center;gap:18px;padding:56px 16px">' +
            '<div style="width:76px;height:76px;border-radius:24px;display:flex;align-items:center;' +
                  'justify-content:center;background:rgba(5,34,43,0.78);' +
                  'border:1px solid rgba(5,34,43,0.78)">' +
              '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#FFC53D" ' +
                'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
                '<path d="M5.4 8h13.2a1 1 0 0 1 1 1.1l-1 9.5a2 2 0 0 1-2 1.8H7.4a2 2 0 0 1-2-1.8' +
                  'l-1-9.5A1 1 0 0 1 5.4 8Z"></path>' +
                '<path d="M8.8 10.5V6.8a3.2 3.2 0 0 1 6.4 0v3.7"></path></svg>' +
            '</div>' +
            '<div>' +
              '<div style="font-family:Anton,sans-serif;font-size:17px;letter-spacing:0.06em;' +
                    'text-transform:uppercase;margin-bottom:8px;color:#05222B;font-family:Archivo,sans-serif;font-weight:700">Your bag is empty</div>' +
              // drawer is cream now: pale text here was invisible against it
              '<p style="font-size:11px;line-height:1.8;letter-spacing:0.08em;text-transform:uppercase;' +
                    'color:rgba(5,34,43,0.78);margin:0;max-width:26ch">' +
                'Pick a colourway and a size, and he is in the club.</p>' +
            '</div>' +
            '<button type="button" data-close-drawer style="margin-top:4px;padding:14px 24px;' +
                  'border-radius:999px;cursor:pointer;background:#FFC53D;color:#05222B;border:none;' +
                  'font-family:Anton,sans-serif;font-size:13px;letter-spacing:0.08em;' +
                  'text-transform:uppercase">Shop the vest</button>' +
          '</div>';
      } else {
        list.innerHTML = cart.map(function (item, i) {
          /* per-colour torso-crop thumbnail. URLs come from the page via
             window.FC_THUMBS because this file cannot resolve theme asset
             URLs itself; with no map or unknown colour, no image, no 404. */
          var thumbUrl = (global.FC_THUMBS || {})[item.colour];
          return '' +
          '<div style="display:flex;gap:14px;align-items:flex-start;padding:16px 0;' +
                'border-bottom:1px solid rgba(5,34,43,0.78)">' +
            (thumbUrl
              ? '<img src="' + esc(thumbUrl) + '" alt="" width="52" height="52" ' +
                'style="width:52px;height:52px;border-radius:12px;object-fit:cover;' +
                'flex:0 0 auto;background:#F2F9FA;margin-top:2px">'
              : '') +
            '<div style="flex:1;min-width:0">' +
              '<div style="font-family:Archivo,sans-serif;font-weight:700;font-size:14px;letter-spacing:0.02em;' +
                    'text-transform:uppercase">' + esc(item.colour) + '</div>' +
              '<div style="font-size:10px;letter-spacing:0.14em;text-transform:uppercase;' +
                    'color:rgba(5,34,43,0.78);margin-top:4px">Size ' + esc(item.size) + '</div>' +
              '<div style="display:flex;align-items:center;gap:8px;margin-top:12px">' +
                '<button type="button" data-qty-dec="' + i + '" aria-label="Decrease quantity" ' +
                  'style="width:30px;height:30px;border-radius:8px;cursor:pointer;' +
                  'background:#FFFFFF;border:1px solid rgba(5,34,43,0.78);' +
                  'color:#05222B;font-size:16px;line-height:1">&minus;</button>' +
                '<span class="fc-num" style="min-width:24px;text-align:center;' +
                      'font-size:14px">' + item.qty + '</span>' +
                '<button type="button" data-qty-inc="' + i + '" aria-label="Increase quantity" ' +
                  'style="width:30px;height:30px;border-radius:8px;cursor:pointer;' +
                  'background:#FFFFFF;border:1px solid rgba(5,34,43,0.78);' +
                  'color:#05222B;font-size:16px;line-height:1">+</button>' +
                '<button type="button" data-qty-rm="' + i + '" ' +
                  'style="margin-left:8px;background:none;border:none;cursor:pointer;' +
                  'font-size:10px;letter-spacing:0.12em;text-transform:uppercase;' +
                  'color:rgba(5,34,43,0.78);text-decoration:underline">Remove</button>' +
              '</div>' +
            '</div>' +
            '<div class="fc-num" style="font-size:15px;color:#05222B;flex:0 0 auto">' +
              fmt(item.qty * UNIT_GBP) +
            '</div>' +
          '</div>';
        }).join("");
      }
    }

    var disc = bundleDiscountGBP(totalQty());
    var discRow = el("fc-drawer-discount");
    if (discRow) {
      discRow.style.display = disc > 0 ? "flex" : "none";
      var dv = el("fc-drawer-discount-value");
      if (dv) dv.textContent = "−" + fmt(disc);
    }

    /* -----------------------------------------------------------------
       Free-shipping progress line at the top of the drawer: a track that
       fills toward the $65 threshold, so "add more" is something you can
       see happening rather than a sentence to believe.
    ----------------------------------------------------------------- */
    var FREE_SHIP_USD = 65;
    var ship = el("fc-ship-progress");
    if (!ship) {
      var itemsHost = el("fc-drawer-items");
      if (itemsHost && itemsHost.parentNode) {
        ship = document.createElement("div");
        ship.id = "fc-ship-progress";
        ship.style.cssText = "padding:14px 24px 4px";
        ship.innerHTML =
          '<div data-ship-label style="font-size:10px;letter-spacing:0.12em;' +
            'text-transform:uppercase;color:rgba(5,34,43,0.78);margin-bottom:8px"></div>' +
          '<div style="height:6px;border-radius:99px;background:rgba(5,34,43,0.10);overflow:hidden">' +
            '<div data-ship-fill style="height:100%;width:0%;border-radius:99px;' +
              'background:linear-gradient(90deg,#FFC53D,#FFB300);' +
              'transition:width .45s cubic-bezier(.22,1,.36,1)"></div>' +
          '</div>';
        itemsHost.parentNode.insertBefore(ship, itemsHost);
      }
    }
    if (ship) {
      var subtotalNow = totalGBP();               /* post-discount, USD-based */
      var pct = Math.max(0, Math.min(100, (subtotalNow / FREE_SHIP_USD) * 100));
      var fill = ship.querySelector("[data-ship-fill]");
      var lbl = ship.querySelector("[data-ship-label]");
      if (fill) fill.style.width = (count > 0 ? pct : 0) + "%";
      if (lbl) {
        if (count === 0) lbl.textContent = "Free shipping on orders over " + fmt(FREE_SHIP_USD);
        else if (subtotalNow >= FREE_SHIP_USD) {
          lbl.textContent = "Free shipping unlocked";
          if (fill) fill.style.background = "#2E9E6B";
        } else {
          lbl.textContent = fmt(FREE_SHIP_USD - subtotalNow) + " away from free shipping";
          if (fill) fill.style.background = "linear-gradient(90deg,#FFC53D,#FFB300)";
        }
      }
    }

    var nudge = el("fc-drawer-nudge");
    if (nudge) {
      if (count === 1) {
        nudge.style.display = "";
        nudge.textContent = "Add one more and save " + fmt(DISCOUNT_AT_2) + ".";
      } else if (count === 2) {
        nudge.style.display = "";
        nudge.textContent = "Add a third and save " + fmt(DISCOUNT_AT_3_PLUS) + " in total.";
      } else {
        nudge.style.display = "none";
      }
    }

    var sub = el("fc-drawer-subtotal");
    if (sub) sub.textContent = fmt(rawSubtotalGBP());
    var tot = el("fc-drawer-total");
    if (tot) tot.textContent = fmt(totalGBP());

    var btn = el("fc-drawer-checkout");
    var notice = el("fc-drawer-notice");
    if (btn) {
      var shopReady = global.FC_SHOPIFY && global.FC_SHOPIFY.isConfigured();
      var fallback = orderFallbackUrl();
      var coReady = global.FC_CHECKOUT && global.FC_CHECKOUT.isConfigured();
      var ready = count > 0 && (shopReady || coReady || !!fallback);
      btn.disabled = !ready;
      // live button carries the brand yellow; dead button is a real grey,
      // never translucent yellow (that rendered as olive sludge)
      btn.style.background = ready ? "#FFC53D" : "#C8D8DC";
      btn.style.color = ready ? "#05222B" : "rgba(5,34,43,0.78)";
      btn.style.cursor = ready ? "pointer" : "not-allowed";
      // disabled alone is not enough: without this the element still takes
      // pointer events in some engines and reads as a live button
      btn.style.pointerEvents = ready ? "auto" : "none";
      btn.setAttribute("aria-disabled", ready ? "false" : "true");
      if (notice) {
        if (count === 0) {
          notice.textContent = "";
        } else if (shopReady) {
          notice.textContent = "Charged in USD. Taxes and shipping calculated at checkout.";
        } else if (coReady) {
          notice.textContent = "Delivery calculated at the next step. Nothing is charged until you " +
            "use the payment link we send you.";
        } else if (fallback) {
          notice.textContent = "Card checkout is being switched on. Send your order and we " +
            "reply with a payment link the same day.";
        } else {
          // customer-facing wording: never surface file paths or config
          // variable names to a shopper. The developer signal goes to the
          // console instead.
          notice.textContent = "Online ordering opens shortly. Contact us and we will " +
            "reserve your size.";
          if (!global.__fcWarned) {
            global.__fcWarned = true;
            console.warn("[FC] Checkout inactive. Set SHOP_DOMAIN + PRODUCT_HANDLE in " +
              "assets/shopify-config.js, or ORDER_EMAIL / ORDER_WHATSAPP in assets/fc-commerce.js.");
          }
        }
      }
    }
  }

  function syncCheckoutLabel() {
    var btn = el("fc-drawer-checkout");
    if (!btn) return;
    var shopReady = global.FC_SHOPIFY && global.FC_SHOPIFY.isConfigured();
    var coReady = global.FC_CHECKOUT && global.FC_CHECKOUT.isConfigured();
    var lbl = btn.querySelector("[data-checkout-label]");
    if (lbl) lbl.textContent = (shopReady || coReady) ? "Checkout" : "Send my order";
  }

  function renderAll() {
    renderCurrencyUI();
    renderCart();
    syncCheckoutLabel();
    // subscribers registered by the page (e.g. the PDP's own price block).
    // One notification point means no surface can lag behind the picker.
    var subs = global.FC_ON_CURRENCY || [];
    for (var i = 0; i < subs.length; i++) {
      try { subs[i](); } catch (e) { /* a bad subscriber must not stop the rest */ }
    }
  }

  /* ---------------------------------------------------------------
     DRAWER
  --------------------------------------------------------------- */
  var lastFocus = null;

  function openDrawer() {
    var d = el("fc-drawer");
    if (!d) return;
    lastFocus = document.activeElement;
    d.style.display = "block";
    requestAnimationFrame(function () {
      var panel = el("fc-drawer-panel");
      var scrim = el("fc-drawer-scrim");
      if (panel) panel.style.transform = "translateX(0)";
      if (scrim) scrim.style.opacity = "1";
    });
    document.body.style.overflow = "hidden";
    var close = el("fc-drawer-close");
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = el("fc-drawer");
    if (!d) return;
    var panel = el("fc-drawer-panel");
    var scrim = el("fc-drawer-scrim");
    if (panel) panel.style.transform = "translateX(100%)";
    if (scrim) scrim.style.opacity = "0";
    document.body.style.overflow = "";
    setTimeout(function () { d.style.display = "none"; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------------------------------------------------------------
     ATTRIBUTION STAMPING — appends the visitor's traffic source onto
     the Shopify cart permalink as attributes[...] params, so it lands
     on the order and is visible in Shopify admin. Reads window.FC_ATTRIB
     (assets/fc-attrib.js, loaded before this file). Silent no-op if
     that module has not run for any reason -- a missing attribution
     tag must never block checkout.
  --------------------------------------------------------------- */
  function stampAttribution(url) {
    if (!url) return url;
    try {
      if (!global.FC_ATTRIB || !global.FC_ATTRIB.get) return url;
      var a = global.FC_ATTRIB.get() || {};
      var last = a.last || {};
      var first = a.first || {};
      var source = last.source || "direct";
      var medium = last.medium || "";
      var campaign = last.campaign || "";
      var firstTouch = (first.source || "direct") + " " + String(first.ts || "").slice(0, 10);
      var landing = String(first.landing || "").slice(0, 120);
      var device = last.device || first.device || "";
      var params = [
        "attributes[source]=" + encodeURIComponent(source),
        "attributes[medium]=" + encodeURIComponent(medium),
        "attributes[campaign]=" + encodeURIComponent(campaign),
        "attributes[first_touch]=" + encodeURIComponent(firstTouch),
        "attributes[landing]=" + encodeURIComponent(landing),
        "attributes[device]=" + encodeURIComponent(device)
      ].join("&");
      if (params.length > 800) return url; // never let a runaway value break checkout
      return url + (url.indexOf("?") === -1 ? "?" : "&") + params;
    } catch (e) {
      return url;
    }
  }

  /* ---------------------------------------------------------------
     WIRING
  --------------------------------------------------------------- */
  function init() {
    document.addEventListener("click", function (e) {
      var t = e.target.closest ? e.target.closest("[data-qty-dec],[data-qty-inc],[data-qty-rm],[data-cur-opt],[data-open-cart],[data-close-drawer]") : null;
      if (!t) return;

      if (t.hasAttribute("data-close-drawer")) {
        closeDrawer();
        var pdp = document.getElementById("product");
        if (pdp) pdp.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }

      if (t.hasAttribute("data-qty-dec")) {
        var i1 = +t.getAttribute("data-qty-dec");
        setQty(i1, cart[i1].qty - 1);
      } else if (t.hasAttribute("data-qty-inc")) {
        var i2 = +t.getAttribute("data-qty-inc");
        setQty(i2, cart[i2].qty + 1);
      } else if (t.hasAttribute("data-qty-rm")) {
        setQty(+t.getAttribute("data-qty-rm"), 0);
      } else if (t.hasAttribute("data-cur-opt")) {
        setCurrency(t.getAttribute("data-cur-opt"));
        var menu = el("fc-cur-menu");
        if (menu) menu.style.display = "none";
      } else if (t.hasAttribute("data-open-cart")) {
        openDrawer();
      }
    });

    var curBtn = el("fc-cur-btn");
    var curMenu = el("fc-cur-menu");
    if (curBtn && curMenu) {
      curBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        var open = curMenu.style.display === "block";
        curMenu.style.display = open ? "none" : "block";
        curBtn.setAttribute("aria-expanded", open ? "false" : "true");
      });
      document.addEventListener("click", function (e) {
        if (!curMenu.contains(e.target) && e.target !== curBtn) {
          curMenu.style.display = "none";
          curBtn.setAttribute("aria-expanded", "false");
        }
      });
    }

    var close = el("fc-drawer-close");
    var scrim = el("fc-drawer-scrim");
    if (close) close.addEventListener("click", closeDrawer);
    if (scrim) scrim.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeDrawer();
        if (curMenu) curMenu.style.display = "none";
      }
    });

    var checkout = el("fc-drawer-checkout");
    if (checkout) {
      checkout.addEventListener("click", function () {
        if (!cart.length) return;
        // real Shopify checkout when the store is wired
        if (global.FC_SHOPIFY && global.FC_SHOPIFY.isConfigured()) {
          var url = global.FC_SHOPIFY.buildCheckoutUrl(cart);
          if (url) { global.location.href = stampAttribution(url); return; }
        }
        // otherwise run our own checkout: contact, address, delivery,
        // review, order placement. Everything except the card charge,
        // which needs a merchant account and cannot live in the page.
        if (global.FC_CHECKOUT && global.FC_CHECKOUT.isConfigured()) {
          closeDrawer();
          setTimeout(function () { global.FC_CHECKOUT.open(); }, 200);
          return;
        }
        var fb = orderFallbackUrl();
        if (fb) global.location.href = fb;
      });
    }

    wireSocial();
    wireTracking();

    // colourway card arrows: actually select that colourway on the PDP rather
    // than dumping the visitor at the checkout section
    document.addEventListener("click", function (e) {
      var a = e.target.closest ? e.target.closest("[data-pick-colour]") : null;
      if (!a) return;
      var want = a.getAttribute("data-pick-colour");
      var swatch = document.querySelector('[data-colour="' + want + '"]');
      if (swatch) swatch.click();
    });

    renderAll();
  }

  global.FC = {
    // read-only view of the cart for the checkout module: a copy, so a
    // consumer cannot mutate cart state behind renderAll()'s back
    items: function () { return cart.map(function (i) { return { colour: i.colour, size: i.size, qty: i.qty }; }); },
    totalQty: totalQty,
    currency: function () { return currency; },
    clear: function () { cart = []; persist(); renderAll(); },
    addItem: addItem,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer,
    setCurrency: setCurrency,
    fmt: fmt,
    totalGBP: totalGBP,
    unitGBP: UNIT_GBP,
    bundleDiscountGBP: bundleDiscountGBP,
    ratesDate: RATES_DATE,
    isConverted: isConverted,
    render: renderAll
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})(window);
